module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pre2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("sa•voir faire")])]), _vm._v(" \\"), _c('span', {
    staticClass: "subscript"
  }, [_vm._v("I")]), _vm._v(" sav-"), _c('span', {
    staticClass: "subscript"
  }, [_vm._v("I")]), _vm._v(" wär-"), _c('sup', {
    staticClass: "superscript"
  }, [_vm._v("I")]), _vm._v("fer\\ "), _c('em', [_vm._v("n.m.")]), _vm._v(" "), _c('strong', [_vm._v("1:")]), _vm._v(" Know-how. French "), _c('em', [_vm._v("savoir-faire")]), _vm._v(", literally, knowing ("), _c('em', [_vm._v("savoir")]), _vm._v(") how to do ("), _c('em', [_vm._v("faire")]), _vm._v("). "), _c('strong', [_vm._v("2:")]), _vm._v(" Competence, experience. "), _c('strong', [_vm._v("3:")]), _vm._v(" The ready knowledge of the right course of action: knowing what to do and say and when and how to do so. "), _c('strong', [_vm._v("4:")]), _vm._v(" "), _c('em', [_vm._v("Habileté dans un art quelconque.")]), _vm._v(" 1784 "), _c('em', [_vm._v("“Pour gagner du bien, le savoir-faire vaut mieux que le savoir")]), _vm._v("."), _c('em', [_vm._v("”")]), _vm._v(" In order to succeed, savoir faire is more important than knowledge. Pierre Augustin Caron de Beaumarchais, "), _c('em', [_vm._v("Le Mariage de Figaro,")]), _vm._v(" V, 3. "), _c('strong', [_vm._v("5:")]), _vm._v(" To be up to snuff with wit of a thing or two. 1815 “He had great confidence in his "), _c('em', [_vm._v("savoir-faire.")]), _vm._v("” Sir Walter Scott, "), _c('em', [_vm._v("Guy Mannering")]), _vm._v(". "), _c('strong', [_vm._v("6:")]), _vm._v(" Operating knowledge of business sense and sensibility.")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ad9c70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm5_pre2.vue
// module id = 75
// module chunks = 0